import React from 'react';
import { Carousel } from 'common/components/carousel/carousel';
import type { BrandItem, BrandsProps } from './types';
import { BrandsItem } from './components/brands-item';
import { analyticsUtils } from 'utils/analytics-utils';
import { extendedClick } from 'utils/extended-click';
import { checkElementName } from './utils/check-element-name';
import { Container } from './styles';

export const Brands = (props: BrandsProps) => {
  const { title, brands, analytics, onImpressionContentClick, onImpressionContentView } = props;
  const contentIdClicked: number[] = [];

  const sendClickToGA = (e: MouseEvent, brand: BrandItem, position: number) => {
    if (analytics && !contentIdClicked.includes(position)) {
      const { elementBlock } = analytics;
      extendedClick(e, () => {
        analyticsUtils.sendEvent('GA:clickButton', {
          elementBlock,
          elementName: checkElementName(brand.banner.targetUrl),
          elementType: 'button',
          elementText: position.toString(),
        });
      });
    }

    contentIdClicked.push(position);
  };

  const handleMouseDown = ({
    e,
    brand,
    position,
  }: {
    e: PointerEvent;
    brand: BrandItem;
    position: number;
  }) => {
    if (onImpressionContentClick) {
      onImpressionContentClick(brand.id);
    }
    sendClickToGA(e, brand, position);
  };

  if (!brands?.content?.length) return null;

  return (
    <Container data-qa="brands">
      <Carousel title={title}>
        {brands.content.map((brandBanner, i) => {
          return (
            <BrandsItem
              brand={brandBanner}
              index={i}
              key={brandBanner.id}
              analytics={analytics}
              onPointerDown={e => handleMouseDown({ e, brand: brandBanner, position: i + 1 })}
              onImpressionContentView={onImpressionContentView}
            />
          );
        })}
      </Carousel>
    </Container>
  );
};
